import parceiro from './handle'
export const ParceiroService  = parceiro
 